module.exports = __webpack_public_path__ + "media/components/assets/sanlim_02-aa0288ae497ee4a0639c3dc9fb5d8cba.jpg";